import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';

const HomePage = () => {
  return (
    <div className="relative">
      {/* Главный экран */}
      <HeroSection />
      
      {/* Поддерживаемые игры — удалено по запросу */}
      
      {/* Преимущества */}
      <FeaturesSection />

      {/* Как это работает (вместо статистики) */}
      <HowItWorksSection />
    </div>
  );
};

export default HomePage;
